package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Button
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.roundToInt


const val SPRING_TRANSLATE_BALL = "674c257eb23170713219efc604161e7d1f66ca12eff640ffee95c1c8c52076f8"

@Composable
fun SpringTranslateBall() {
    Row(
        Modifier.fillMaxSize()
    ) {
        var atTop by remember { mutableStateOf(true) }
        var bottomOffset by remember { mutableStateOf(0f) }
        val topOffset by animateFloatAsState(
            targetValue = if (atTop) 0f else bottomOffset,
            animationSpec = spring(
                dampingRatio = .1f,
                stiffness = Spring.StiffnessLow,
            )
        )

        val density = LocalDensity.current
        Box(Modifier
            .fillMaxHeight()
            .weight(1f)
            .onSizeChanged {
                bottomOffset = it.height - with(density) { 100.dp.toPx() }
            },
            contentAlignment = Alignment.TopCenter
        ) {
            Box(Modifier
                .offset { IntOffset(0, topOffset.roundToInt()) }
                .size(100.dp)
                .background(color = Color(0xff52d3f7), shape = CircleShape)
            )
        }

        Box(Modifier
            .fillMaxHeight()
            .weight(1f),
            contentAlignment = Alignment.Center
        ) {
            Button(onClick = {atTop = !atTop}) {
                Text("Switch", fontWeight = FontWeight.Black)
            }
        }
    }
}